module.exports = __webpack_public_path__ + "media/notify.55342729.mp3";